const dialogs = document.querySelectorAll('.awp_notify-me__dialog');

dialogs.forEach((dialog) => {
  const productForm = dialog.closest('awp-product-form');
  if (!productForm) return;

  const addToCartBtn = productForm.querySelector('[ref="addToCartBtn"]');
  if (!addToCartBtn) return;

  const form = dialog.querySelector('.awp_notify-me__form');
  const closeBtn = dialog.querySelector('.awp_notify-me__close');
  const emailInput = dialog.querySelector('.awp_notify-me__input');
  const errorEl = dialog.querySelector('.awp_notify-me__error');
  const submitBtn = dialog.querySelector('.awp_notify-me__submit');
  const successEl = dialog.querySelector('.awp_notify-me__success');

  let isNotifyMode = addToCartBtn.hasAttribute('data-notify-trigger');
  let awp_autoCloseTimer = null;

  addToCartBtn.addEventListener('click', () => {
    if (isNotifyMode) dialog.showModal();
  });

  closeBtn.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('close', () => {
    clearTimeout(awp_autoCloseTimer);
    form.hidden = false;
    emailInput.value = '';
    errorEl.hidden = true;
    errorEl.textContent = '';
    submitBtn.disabled = false;
    submitBtn.textContent = dialog.dataset.submitText || 'Notify Me';
    successEl.hidden = true;
    successEl.textContent = '';
  });

  productForm.addEventListener('change', () => {
    setTimeout(() => {
      if (addToCartBtn.disabled) {
        transformToNotify();
      } else if (isNotifyMode) {
        restoreToCart();
      }
    }, 0);
  });

  function transformToNotify() {
    isNotifyMode = true;
    addToCartBtn.disabled = false;
    addToCartBtn.type = 'button';
    addToCartBtn.textContent = addToCartBtn.dataset.notifyText || 'Notify Me';
    addToCartBtn.classList.add('awp_add-to-cart__btn--notify');
  }

  function restoreToCart() {
    isNotifyMode = false;
    addToCartBtn.type = 'submit';
    addToCartBtn.classList.remove('awp_add-to-cart__btn--notify');
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const email = emailInput.value.trim();
    if (!email || !emailInput.validity.valid) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.hidden = false;
      return;
    }

    const publicKey = dialog.dataset.publicKey;
    if (!publicKey) {
      errorEl.textContent = 'Configuration error. Please contact the store.';
      errorEl.hidden = false;
      return;
    }

    let variantId = dialog.dataset.variantId;
    const variantInput = productForm.querySelector('[ref="variantInput"]');
    if (variantInput && variantInput.value) variantId = variantInput.value;

    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';
    errorEl.hidden = true;
    errorEl.textContent = '';

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${publicKey}`,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            revision: '2023-12-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          })
        }
      );

      if (response.status === 202) {
        form.hidden = true;
        successEl.textContent = dialog.dataset.successMessage;
        successEl.hidden = false;
        awp_autoCloseTimer = setTimeout(() => dialog.close(), 3000);
      } else {
        const data = await response.json().catch(() => ({}));
        const msg = data?.errors?.[0]?.detail || 'Something went wrong. Please try again.';
        errorEl.textContent = msg;
        errorEl.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    } catch {
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.hidden = false;
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    }
  });
});
